import React from 'react';
import { Field } from 'formik';
import PropTypes from 'prop-types';

import SSRSafeElement from 'commons/SSRSafeElement';
import BaseField from './BaseField';

const SmartyStreetsFloatingField = ({
  id = 'address',
  name = 'address',
  value,
  error,
  showError,
  isTouched,
  handleBlur,
  handleChange,
  setFieldValue,
  isRequired = true,
  refField = null,
  ...props
}) => (
  <Field
    id={id}
    name={name}
    render={({ field }) => (
      <BaseField
        type="text"
        field={field}
        value={value}
        onBlur={handleBlur}
        onChange={handleChange}
        setFieldValue={setFieldValue}
        placeholder="Street address *"
        autoComplete="address-line1"
        errorState={isTouched && error}
        data-xc="shipping-address-field"
        required={isRequired ? '' : undefined}
        aria-required={isRequired ? '' : undefined}
        refField={refField}
        errorMessage={showError && isTouched && error}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    )}
  />
);

SmartyStreetsFloatingField.propTypes = {
  addressFieldName: PropTypes.string,
  stateFieldName: PropTypes.string,
  cityFieldName: PropTypes.string,
  zipCodeFieldName: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.string,
  showError: PropTypes.bool,
  isTouched: PropTypes.bool,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  setFieldValue: PropTypes.func,
  isRequired: PropTypes.bool,
  refField: PropTypes.shape({
    current: PropTypes.instanceOf(SSRSafeElement),
  }),
};

export default SmartyStreetsFloatingField;
